// KPI library - CRUD operations for kpi_definitions
// CREATED: KPI system v1 - minimal KPI management for analytics dashboard

import { supabase } from './supabase';

export interface KpiDefinition {
  id: string;
  name: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export type KpiResult<T> =
  | { success: true; data: T }
  | { success: false; error: string };

export async function getKpiDefinitions(): Promise<KpiResult<KpiDefinition[]>> {
  const { data, error } = await supabase
    .from('kpi_definitions')
    .select('*')
    .eq('is_active', true)
    .order('name', { ascending: true });

  if (error) {
    return { success: false, error: error.message };
  }

  return { success: true, data: data || [] };
}

export async function createKpiDefinition(name: string): Promise<KpiResult<KpiDefinition>> {
  const trimmed = name.trim();
  if (!trimmed) {
    return { success: false, error: "Le nom de l'indicateur est obligatoire" };
  }

  const { data, error } = await supabase
    .from('kpi_definitions')
    .insert({ name: trimmed })
    .select()
    .single();

  if (error) {
    return { success: false, error: error.message };
  }

  return { success: true, data };
}
